import { useEffect, useState } from "react";
import axios from "../helpers/axios";

// Add product to an order
export const addOrderedProduct = async (values, callback) => {
  try {
    const res = await axios.post(`/ordered-products/add`, values);
    callback(res.data);
  } catch (error) {
    console.error("Error adding product to order:", error);
    callback({ status: 500, message: "Failed to add product to order" });
  }
};

// Update ordered product quantity
export const updateOrderedProduct = async (id, values, callback) => {
  try {
    const res = await axios.put(`/ordered-products/update/${id}`, values);
    callback(res.data);
  } catch (error) {
    console.error("Error updating ordered product:", error);
    callback({ status: 500, message: "Failed to update product quantity" });
  }
};

// Remove product from order
export const removeOrderedProduct = async (id, callback) => {
  try {
    const res = await axios.delete(`/ordered-products/remove/${id}`);
    callback(res.data);
  } catch (error) {
    console.error("Error removing product from order:", error);
    callback({ status: 500, message: "Failed to remove product from order" });
  }
};

// Get all products for an order
export const getOrderedProducts = async (orderId, callback) => {
  try {
    const res = await axios.get(`/ordered-products/order/${orderId}`);
    callback(res.data || { data: [], count: 0 }); // Ensure empty data is handled
  } catch (error) {
    console.error("Error fetching ordered products:", error);
    callback({ data: [], count: 0 }); // Prevents UI crash
  }
};

// Get single ordered product by ID
export const getOrderedProductById = async (id, callback) => {
  try {
    const res = await axios.get(`/ordered-products/${id}`);
    callback(res.data);
  } catch (error) {
    console.error("Error fetching ordered product:", error);
    callback({ status: 404, message: "Ordered product not found" });
  }
};

// Ordered Products API Hook for managing state
export const OrderedProductsAPI = () => {
  const [orderedProducts, setOrderedProducts] = useState([]);
  const [orderedProductDetail, setOrderedProductDetail] = useState({});
  const [orderId, setOrderId] = useState(null);
  const [callback, setCallback] = useState(false);

  useEffect(() => {
    if (orderId) {
      getOrderedProducts(orderId, (res) => {
        setOrderedProducts(res.response);
      });
    }
  }, [callback, orderId]);

  return {
    orderedProducts: [orderedProducts, setOrderedProducts],
    orderedProductDetail: [orderedProductDetail, setOrderedProductDetail],
    orderId: [orderId, setOrderId],
    callback: [callback, setCallback],
  };
};
